import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';

export default Route.extend({
  navbarSettings: service(),
  settings: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'User Settings');
  },

  model() {
    let record = get(this, 'settings.userSettings');
    return {
      record,
      changeset: new Changeset(record),
    };
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
